import { ComponentType } from 'react'

import { ErrorBoundary } from '@/features/errors'

export function withErrorBoundary<T extends {}>(
  WrappedComponent: ComponentType<T>,
  FallbackComponent: ComponentType<{}>,
): ComponentType<T> {
  // eslint-disable-next-line func-style
  const ComponentWithErrorBoundary = (props: T) => (
    <ErrorBoundary fallback={<FallbackComponent />}>
      <WrappedComponent {...props} />
    </ErrorBoundary>
  )

  ComponentWithErrorBoundary.displayName = WrappedComponent.displayName || WrappedComponent.name
  return ComponentWithErrorBoundary
}
